import { Button, Card, Heading } from '@appd/uik';
import { DashifyEditorExpressions } from '../expressions/DashifyEditorExpressions';
import { Dispatch, SetStateAction, useState } from 'react';
import { keys } from 'lodash';

interface DashifyInspectPanelProps {
  fullInspectMode: boolean;
  queryKey: string;
  queryResult: Record<string, unknown>;
  expressionsJSON: any;
  stageExpressionUpdate: (expr: string, key?: string) => void;
  setFullInspectMode: Dispatch<SetStateAction<boolean>>;
  setInspectMode: Dispatch<SetStateAction<boolean>>;
}

const filterQueryResultByKey = (queryResult: any, queryKeys: string[]) => {
  const filtered = keys(queryResult.data)
    .filter((key: string) => queryKeys.includes(key))
    .reduce((acc: any, key: string) => {
      acc[key] = queryResult.data[key];
      return acc;
    }, {} as Record<string, any>);
  return { data: filtered };
};

export const DashifyInspectPanel: React.FC<DashifyInspectPanelProps> = ({
  fullInspectMode,
  queryKey,
  queryResult,
  expressionsJSON,
  stageExpressionUpdate,
  setFullInspectMode,
  setInspectMode,
}) => {
  const [queryKeys, setQueryKeys] = useState<string[]>([queryKey]);

  return (
    <div className={`h-full z-10 ${fullInspectMode ? 'w-full' : 'w-[400px]'}`} data-testid="dashify-inspect-panel">
      <Card.Container
        style={{
          height: 'calc(100%)',
          borderRadius: 0,
          boxShadow: 'none',
          overflow: 'auto',
          paddingBottom: 0,
        }}
      >
        <div className="flex flex-row items-center justify-between">
          <Heading size="PRIMARY">Inspect Data</Heading>
          <Button
            data-testid="dashify-inspect-mode"
            type="TERTIARY"
            icon="Action.Disable"
            onClick={() => setInspectMode(false)}
          />
        </div>

        {/* Inspect Panel */}
        <DashifyEditorExpressions
          data={filterQueryResultByKey(queryResult, queryKeys)}
          expression={expressionsJSON}
          isFullInspectMode={fullInspectMode}
          onSave={stageExpressionUpdate}
          setDataSources={setQueryKeys}
          setFullInspectMode={(bool: boolean) => setFullInspectMode(bool)}
        />
      </Card.Container>
    </div>
  );
};
